<template>
  <div class="container">
    <QueryFrame
      :addText="handlePermission('assetsTypeAdd')?'新建设备类型':''"
      @addNew="showAssetsModal(1)"
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :disablePage='disablePage'
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>设备大类:</label>
            <lk-select class="item" clearable v-model.trim='query.category'>
              <lk-option v-for="item in categoryArray" :key="item.id" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>类型名称:</label>
            <lk-input :maxlength="100" clearable placeholder="请输入" class="item" v-model.trim='query.name'></lk-input>
          </div>
          <div class="queryItem">
            <label>创建人:</label>
            <lk-input :maxlength="100" clearable placeholder="请输入" class="item" v-model.trim='query.curingUserName'></lk-input>
          </div>
          <div class="queryItem">
            <label >养护周期(天):</label>
            <lk-input-number
              class="item"
              clearable
              v-model.trim="query.curingCycle"
              :min="1" :max="9999"
              :precision="0"
              placeholder="请输入">
            </lk-input-number>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker type='daterange' class="item" clearable placeholder=" 请选择"  v-model.trim='query.duration' />
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <lk-modal
      v-model="assetsModal.visiable"
      :mask-closable="false"
      :title="assetsModal.type === 1 ? '新增设备类型' : '编辑'">
      <lk-form :model='formModel' :label-width="120" ref="assetsForm">
        <lk-row>
          <lk-col span='22'>
            <lk-form-item
              label='设备大类：'
              :rules="{
                required: assetsModal.type === 1,
                message: '请选择设备大类',
                type: 'number',
                trigger: 'change',
              }"
              prop="category">
              <lk-select
                clearable
                v-model='formModel.category'
                :disabled="assetsModal.type === 2">
                <lk-option v-for="item in categoryArray" :key="item.id" :value="item.id">
                  {{item.name}}
                </lk-option>
              </lk-select>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row>
          <lk-col span='22'>
            <lk-form-item
              label='类型名称：'
              :rules="[
                { required: assetsModal.type === 1, message: '请输入设备名称', trigger: 'blur'},
                { validator: this.nameExistValidator, trigger: 'blur' },
              ]"
              prop="name">
              <lk-input
                style="width: 100%;"
                :maxlength='10'
                v-model.trim="formModel.name"
                placeholder='请输入'
                :disabled="assetsModal.type === 2"
                :clearable="assetsModal.type === 1">
              </lk-input>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row>
          <lk-col span='22'>
            <lk-form-item
              label='养护周期(天)：'
              :rules="[
                { required: true, message: '请输入养护周期', type: 'number', trigger: 'blur' },
                { validator: this.isNumber, trigger: 'blur' },
              ]"
              prop="curingCycle">
              <lk-input-number
                style="width: 100%;"
                clearable
                v-model.trim="formModel.curingCycle"
                :min="1"
                :max="9999"
                :precision="0"
                placeholder='请输入'>
              </lk-input-number>
            </lk-form-item>
          </lk-col>
        </lk-row>
      </lk-form>
      <div slot="footer">
        <div class="queryItem">
          <lk-button @click="hideFormModal">取消</lk-button>
          <lk-button type='primary' class="mr" @click="assertsFormAction(true, true)" :loading="loading">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
// import timeStampDatePicker from '../../components/timeStampDatePicker.vue';
import assets from '../../services/assets';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';

export default {
  mixins: [mapState, queryMixins],
  data() {
    return {
    	loading: false,
      columns: [
        { title: '序号', key: 'index', width: 60 },
        { title: '设备大类', key: 'categoryStr', minWidth: 125 },
        { title: '类型名称', key: 'name', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '养护周期(天)', key: 'curingCycleStr', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '最后修改时间', key: 'modifiedTime', minWidth: 126 },
        {
          title: '状态',
          key: 'statusStr',
          minWidth: 80,
          render: (h, params) => (
            this.handlePermission('assetsTypeEdit') ? h('lk-switch', {
              props: {
                size: 'large',
                value: params.row.status === 1,
                loading: params.row.loading,
              },
              on: {
                'on-change': (value) => {
	                this.assetsModal.type = 2;
	                this.formModel.id = params.row.id;
	                this.formModel.category = params.row.category;
	                this.formModel.name = params.row.name;
	                this.formModel.curingCycle = params.row.curingCycle;
	                this.formModel.status = value ? 1 : 2;
                  this.assertsFormAction(true);
                },
              },
            }, [
              h('span', {
                slot: 'open',
              }, '启用'),
              h('span', {
                slot: 'close',
              }, '禁用'),
            ]) : h('span', params.row.status === 1 ? '启用' : '禁用')),
        },
        {
          title: '操作',
          key: 'action',
          width: 80,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            this.handlePermission('assetsTypeEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
	                this.showAssetsModal(2);
	                this.formModel.id = params.row.id;
	                this.formModel.category = params.row.category;
	                this.formModel.name = params.row.name;
	                this.formModel.curingCycle = params.row.curingCycle;
	                this.formModel.status = params.row.status;
                },
              },
            }, '编辑') : null,
          ]),
        },
      ],
      tableData: [],
      query: {
        category: '', // 设备大类
        name: '', // 类型名称
        curingUserName: '', // 创建人
        curingCycle: null, // 养护周期
        duration: [],
      },
      statusMap: {
        1: '启用',
        2: '禁用',
      },
      formModel: {
	      category: null, // 设备大类
	      name: null, // 类型名称
	      curingCycle: null, // 养护周期
	      status: 1, // 状态 1:启用 2:禁用
        id: null, // 修改时候的标识
      },
	    assetsModal: {
    		visiable: false,
		    type: null, // 1:新增 2:修改
      },
      categoryArray: [{
        id: 1,
        name: '办公设备',
      }, {
        id: 2,
        name: '药品养护设备',
      }, {
        id: 3,
        name: '计量器具',
      }, {
        id: 4,
        name: '冷藏储存设备',
      }],
    };
  },
  mounted() {
    this.handleSearch(true);
  },
  methods: {
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration && this.params.duration.length === 2) {
        this.params.acquisitionStartTime = this.params.duration[0];
        this.params.acquisitionEndTime = this.params.duration[1];
        delete this.params.duration;
      }
      assets.typeList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item, index) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTime = utils.exchangeTime(result.createTime);
            result.modifiedTime = utils.exchangeTime(result.modifiedTime);
            result.statusStr = this.statusMap[result.status];
            result.curingCycleStr = `${result.curingCycle}天`;
	          result.index = index + 1 + (this.page - 1) * this.size;
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    nameExistValidator(rule, value, callback) {
	    if (this.assetsModal.type === 1) {
		    this.$store.commit('setDisableLoading', true);
		    assets.isAssertsTypeNameExist({ name: value }).then((res) => {
			    if (res.data.status === 200) {
				    if (res.data.data) {
					    callback(new Error('设备类型名称已存在.'));
				    } else {
					    callback();
				    }
			    } else {
				    this.$Message.error(res.data.error);
				    callback();
			    }
		    }).catch((err) => {
			    utils.handleError(err);
			    callback();
		    });
      } else {
		    callback();
      }
    },
    isNumber(rule, value, callback) {
      if (utils.forbiddenDate.signlessIntegerValidator(value)) {
        callback();
      } else {
        callback(new Error('养护周期请输入整数.'));
      }
    },
    hideFormModal() {
      this.assetsModal.visiable = false;
    },
    clear() {
      this.query = {
        duration: [],
        curingCycle: null,
      };
    },
	  showAssetsModal(flag) {
      this.assetsModal.visiable = true;
      this.assetsModal.type = flag;
	    this.$refs.assetsForm.resetFields();
    },
    assertsFormAction(flag, isEdit) { // flag 控制全局loading
	    this.$refs.assetsForm.validate((valid) => {
        if (valid) {
          const params = utils.deepClone(this.formModel);
          let actionFn = assets.assertsTypeAdd;
          let successStr = '保存成功';
          if (this.assetsModal.type === 1) { // 新增
            delete params.id;
          } else { // 编辑
            if (isEdit) {
              actionFn = assets.assertsTypeEditUpdate;
            } else {
              actionFn = assets.assertsTypeUpdate;
            }
          	delete params.category;
          	delete params.name;
	          successStr = '更新成功';
          }

	        if (!flag) { // list页面启用或者禁用状态，需要loading
		        this.$store.commit('setDisableLoading', true);
          }
	        this.loading = true;
	        actionFn(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success(successStr);
              this.getData();
            } else {
              this.$Message.error(res.data.error);
            }
		        this.loading = false;
            this.hideFormModal();
          });
        } else {
	        this.loading = false;
          this.$Message.error('请按照要求填写');
        }
      });
      return false;
    },
  },
  created() {
    // this.getTypeList();
    // this.getData();
  },
  components: {
    QueryFrame,
    // timeStampDatePicker,
  },
};
</script>

<style lang="less" scoped>
  .btns{
    display: flex;
    // justify-content: space-between;
    margin-bottom: 12px;
    // padding-top: 16px;
    div:last-child>*{
      margin-left: 16px
    }
    >*{
      margin-right: 16px
    }
  }
</style>
